import { Heart } from 'lucide-react'
import { useUser } from '../contexts/UserContext'

const Footer = () => {
  const { user } = useUser()
  return (
    <footer className="bg-gradient-to-b from-neutral-900 to-neutral-950 text-white border-t border-neutral-800">
      <div className="container section-sm">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="/harvesthelp-logo.png"
                alt="HarvestHelp"
                className="w-10 h-10 rounded-xl object-cover shadow-lg"
              />
              <span className="text-2xl font-bold tracking-tight">HarvestHelp</span>
            </div>
            <p className="text-neutral-400 mb-6 max-w-md leading-relaxed">
              Connecting food banks with suppliers via volunteers to reduce food waste 
              and help communities in need. Together, we're building a more sustainable future.
            </p>
            {/* Removed hardcoded impact statistics */}
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">For Organizations</h3>
            <ul className="space-y-3 text-neutral-300">
              <li><a href="/food-banks" className="hover:text-primary-400 transition-colors duration-200 flex items-center group">
                <div className="w-1 h-1 bg-primary-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200"></div>
                Food Banks
              </a></li>
              <li><a href="/suppliers" className="hover:text-primary-400 transition-colors duration-200 flex items-center group">
                <div className="w-1 h-1 bg-primary-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200"></div>
                Suppliers
              </a></li>
              {/* Only show volunteers link if user is not a volunteer */}
              {user?.userType !== 'VOLUNTEER' && (
                <li><a href="/volunteers" className="hover:text-primary-400 transition-colors duration-200 flex items-center group">
                  <div className="w-1 h-1 bg-primary-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200"></div>
                  Volunteers
                </a></li>
              )}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Support</h3>
            <ul className="space-y-3 text-neutral-300">
              <li><a href="/contact" className="hover:text-primary-400 transition-colors duration-200 flex items-center group">
                <div className="w-1 h-1 bg-primary-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200"></div>
                Contact Us
              </a></li>
              <li><a href="/our-story" className="hover:text-primary-400 transition-colors duration-200 flex items-center group">
                <div className="w-1 h-1 bg-primary-400 rounded-full mr-3 group-hover:scale-150 transition-transform duration-200"></div>
                About
              </a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Follow Garrett</h3>
            <ul className="space-y-3 text-neutral-300">
              <li>
                <a 
                  href="https://globalhungerdashboard.com" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-primary-400 transition-colors duration-200 flex items-center group"
                >
                  <svg className="w-4 h-4 mr-3 group-hover:scale-110 transition-transform duration-200" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
                  </svg>
                  Global Hunger Dashboard
                </a>
              </li>
              <li>
                <a 
                  href="https://garrbearsblog.wordpress.com/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-primary-400 transition-colors duration-200 flex items-center group"
                >
                  <svg className="w-4 h-4 mr-3 group-hover:scale-110 transition-transform duration-200" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm-1 3v8h8v-2h-6V5h-2z"/>
                  </svg>
                  Garrett&apos;s Personal Blog
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-neutral-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 gap-4">
            <p className="text-neutral-500 text-sm">&copy; 2025 HarvestHelp. All rights reserved.</p>
            <div className="flex items-center space-x-6 text-sm text-neutral-400">
              <span>Made with</span>
              <Heart className="h-4 w-4 text-red-500 animate-pulse-soft" />
              <span>for the community</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 